import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Checkout from './Checkout';

// Initialize Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentWrapper = ({ planData, customerData, onSuccess, onError, onCancel }) => {
  return (
    <Elements stripe={stripePromise}>
      <Checkout
        planData={planData}
        customerData={customerData}
        onSuccess={onSuccess}
        onError={onError}
        onCancel={onCancel}
      />
    </Elements>
  );
};

export default PaymentWrapper; 